import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { priceNumber } from '@frontend/utils/priceNumber';
import { animate, motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import * as React from 'react';

var Span = /*#__PURE__*/_styled(motion.span, true ? {
  target: "e1djvw730"
} : {
  target: "e1djvw730",
  label: "Span"
})(true ? {
  name: "1r5gb7q",
  styles: "display:inline-block"
} : {
  name: "1r5gb7q",
  styles: "display:inline-block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvYXBwcy9mcm9udGVuZC9zcmMvY29tcG9uZW50cy9OdW1iZXJDb3VudGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZZ0MiLCJmaWxlIjoiL3ZlcmNlbC9wYXRoMC9hcHBzL2Zyb250ZW5kL3NyYy9jb21wb25lbnRzL051bWJlckNvdW50ZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBwcmljZU51bWJlciB9IGZyb20gJ0Bmcm9udGVuZC91dGlscy9wcmljZU51bWJlcidcbmltcG9ydCB7IGFuaW1hdGUsIG1vdGlvbiB9IGZyb20gJ2ZyYW1lci1tb3Rpb24nXG5pbXBvcnQgeyB1c2VFZmZlY3QsIHVzZVJlZiB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0ICogYXMgUmVhY3QgZnJvbSAncmVhY3QnXG5cbmludGVyZmFjZSBQcm9wcyB7XG4gIGZyb206IG51bWJlclxuICB0bzogbnVtYmVyXG4gIGR1cmF0aW9uPzogbnVtYmVyXG59XG5cbmNvbnN0IFNwYW4gPSBzdHlsZWQobW90aW9uLnNwYW4pYFxuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG5gXG5jb25zdCBDb3VudGVyOiBSZWFjdC5GQzxQcm9wcz4gPSAoeyBmcm9tLCB0bywgZHVyYXRpb24gPSAyIH0pID0+IHtcbiAgY29uc3Qgbm9kZVJlZiA9IHVzZVJlZjxIVE1MU3BhbkVsZW1lbnQ+KClcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIGNvbnN0IG5vZGUgPSBub2RlUmVmLmN1cnJlbnRcblxuICAgIGNvbnN0IGNvbnRyb2xzID0gYW5pbWF0ZShmcm9tLCB0bywge1xuICAgICAgZHVyYXRpb24sXG4gICAgICBvblVwZGF0ZSh2YWx1ZSkge1xuICAgICAgICBub2RlLnRleHRDb250ZW50ID0gcHJpY2VOdW1iZXIodmFsdWUpXG4gICAgICB9XG4gICAgfSlcblxuICAgIHJldHVybiAoKSA9PiBjb250cm9scy5zdG9wKClcbiAgfSwgW2R1cmF0aW9uLCBmcm9tLCB0b10pXG5cbiAgcmV0dXJuIDxTcGFuIHJlZj17bm9kZVJlZn0gLz5cbn1cbmV4cG9ydCBjb25zdCBOdW1iZXJDb3VudGVyOiBSZWFjdC5GQzxQcm9wcz4gPSAoeyBmcm9tLCB0bywgZHVyYXRpb24gPSAxIH0pID0+IHtcbiAgY29uc3QgcHJldlRvUmVmID0gdXNlUmVmKCkgPz8geyBjdXJyZW50OiBmcm9tIH1cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBwcmV2VG9SZWYuY3VycmVudCA9IHRvXG4gIH0pXG4gIHJldHVybiA8Q291bnRlciBmcm9tPXtwcmV2VG9SZWYuY3VycmVudCA/PyBmcm9tfSB0bz17dG99IGR1cmF0aW9uPXtkdXJhdGlvbn0gLz5cbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var Counter = function Counter(_ref) {
  var from = _ref.from,
      to = _ref.to,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 2 : _ref$duration;
  var nodeRef = useRef();
  useEffect(function () {
    var node = nodeRef.current;
    var controls = animate(from, to, {
      duration: duration,
      onUpdate: function onUpdate(value) {
        node.textContent = priceNumber(value);
      }
    });
    return function () {
      return controls.stop();
    };
  }, [duration, from, to]);
  return _jsx(Span, {
    ref: nodeRef
  });
};

export var NumberCounter = function NumberCounter(_ref2) {
  var _useRef, _prevToRef$current;

  var from = _ref2.from,
      to = _ref2.to,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === void 0 ? 1 : _ref2$duration;
  var prevToRef = (_useRef = useRef()) !== null && _useRef !== void 0 ? _useRef : {
    current: from
  };
  useEffect(function () {
    prevToRef.current = to;
  });
  return _jsx(Counter, {
    from: (_prevToRef$current = prevToRef.current) !== null && _prevToRef$current !== void 0 ? _prevToRef$current : from,
    to: to,
    duration: duration
  });
};